import { Alert } from '@uhg-abyss/web/ui/Alert';
import { find } from 'lodash';

import { ConstantsLagoon } from '../../../../common/ConstantsLagoon';
import { useLagoon } from '../../../../hooks/useLagoon';

interface MedicalSpecialistsAlertBannerProps {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
}

export const MedicalSpecialistsAlertBanner = ({
  isVisible,
  setIsVisible,
}: MedicalSpecialistsAlertBannerProps): JSX.Element => {
  const lagoonUIMessage = useLagoon('ui-messaging')();
  const medicalSpecialistsBannerHeader = find(lagoonUIMessage, {
    key: ConstantsLagoon.UI_MESSAGING.MEDICAL_COVERAGE_PROVIDERS_ALERT_HEADER,
  })?.message;

  const medicalSpecialistsBannerDesc = find(lagoonUIMessage, {
    key: ConstantsLagoon.UI_MESSAGING
      .MEDICAL_COVERAGE_PROVIDERS_ALERT_DESCRIPTION,
  })?.message;

  const bannerCTA = find(lagoonUIMessage, {
    key: ConstantsLagoon.MIXED_SEARCH_RESULT_PAGE.VIEW_VISION_COVERAGE_CTA_URL,
  });

  const bannerCTAButton = bannerCTA?.message;

  const bannerCTALink = bannerCTA?.url;

  return (
    <Alert
      cta={{
        type: 'link',
        props: {
          children: bannerCTAButton,
          hideIcon: true,
          href: bannerCTALink,
          openNewWindow: false,
        },
      }}
      data-testid="medical-specialist-alert-banner"
      isVisible={isVisible}
      onClose={() => {
        setIsVisible(false);
      }}
      status="info"
      title={medicalSpecialistsBannerHeader}
    >
      {medicalSpecialistsBannerDesc}
    </Alert>
  );
};
